module.exports = __webpack_public_path__ + "static/media/dark-check.48b7d432.svg";